export default "__VITE_ASSET__BjYrABWQ__"